import React from "react";
import { Edit } from "react-admin";
import { UserForm } from "./UserForm";

export const UserEdit = (props) => (
  <Edit title="Editar Usuário" {...props}>
    <UserForm {...props} />
  </Edit>
);
